import React from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Theaters, Search, Schedule } from "@mui/icons-material";

const getDefaultCopy = (locationText: string) => ({
  boxOneHeader: "Browse Movie Showtimes",
  boxOneText: `Every movie showtime for all cinemas in ${locationText} on one page. No more trawling between different websites.`,

  boxTwoHeader: "Buy Cinema Tickets",
  boxTwoText: `Easily buy tickets for every film showing near you. Compare different showtimes to get the cheapest cinema tickets.`,

  boxThreeHeader: "Never Miss Another Film",
  boxThreeText:
    "View every film that is scheduled to be shown near you, from blockbusters to independent cinema.",
});

export const LandingPageDescriptionBoxes: React.FC<{
  locationText: string;
  boxOneHeader?: string;
  boxOneText?: string;
  boxTwoHeader?: string;
  boxTwoText?: string;
  boxThreeHeader?: string;
  boxThreeText?: string;
}> = ({
  locationText,
  boxOneHeader,
  boxOneText,
  boxTwoHeader,
  boxTwoText,
  boxThreeHeader,
  boxThreeText,
}) => {
  const theme = useTheme();

  const defaultCopy = getDefaultCopy(locationText);

  return (
    <Container
      sx={{
        py: { xs: 1, md: 2 },
        px: { xs: 1, md: 1 },
        width: { md: "80%", xs: "95%" },
      }}
    >
      <Grid container spacing={4}>
        {[
          {
            title: boxOneHeader ?? defaultCopy.boxOneHeader,
            text: boxOneText ?? defaultCopy.boxOneText,
            icon: (
              <Search
                fontSize="large"
                sx={{ color: theme.palette.primary.main }}
              />
            ),
          },
          {
            title: boxTwoHeader ?? defaultCopy.boxTwoHeader,
            text: boxTwoText ?? defaultCopy.boxTwoText,
            icon: (
              <Theaters
                fontSize="large"
                sx={{ color: theme.palette.primary.main }}
              />
            ),
          },
          {
            title: boxThreeHeader ?? defaultCopy.boxThreeHeader,
            text: boxThreeText ?? defaultCopy.boxThreeText,
            icon: (
              <Schedule
                fontSize="large"
                sx={{ color: theme.palette.primary.main }}
              />
            ),
          },
        ].map((feature) => (
          <Grid item xs={12} md={4} key={feature.title}>
            <Card
              elevation={3}
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                // bgcolor: "background.paper",
                bgcolor: "#141414",
                borderRadius: 2,
              }}
            >
              <CardContent>
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  marginBottom={1}
                >
                  {/* {feature.icon} */}
                  <Typography
                    variant="h6"
                    component="h2"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: "large", xs: "medium" },
                      color: theme.palette.primary.main,
                      //textDecoration: "underline",
                    }}
                  >
                    {feature.title}
                  </Typography>
                </Stack>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { md: "small", xs: "small" },
                    textAlign: "left",
                  }}
                >
                  {feature.text}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};
